import happyPath from "./happy-path.json";
import invalidInput from "./invalid-input.json";
import boundary from "./boundary.json";
import adversarial from "./adversarial.json";
import dependencyDown from "./dependency-down.json";

export interface FixtureDescriptor {
  id: string;
  label: string;
  description: string;
  input: unknown;
}

export const FIXTURES: FixtureDescriptor[] = [
  {
    id: "happy-path",
    label: "Camino feliz — clientes",
    description: "Dataset típico de clientes con nombre, email, teléfono, IP y notas libres.",
    input: happyPath,
  },
  {
    id: "invalid-input",
    label: "Entrada inválida",
    description: "La envolvente de entrada viola el contrato (scenarioId, propiedades no permitidas).",
    input: invalidInput,
  },
  {
    id: "boundary",
    label: "Límite de tamaño",
    description: "500 filas: exactamente en el máximo soportado por el motor.",
    input: boundary,
  },
  {
    id: "adversarial",
    label: "Contenido hostil",
    description: "Cadenas con intentos de XSS/inyección dentro del propio dataset.",
    input: adversarial,
  },
  {
    id: "dependency-down",
    label: "Adaptador remoto deshabilitado",
    description: "Solicita un modo no determinista; el kill switch fuerza el motor local.",
    input: dependencyDown,
  },
];

export function getFixtureById(id: string): FixtureDescriptor | undefined {
  return FIXTURES.find((fixture) => fixture.id === id);
}
